import { FC } from "react";
import { App } from "../App";
import { Routes, Route, BrowserRouter  } from "react-router-dom";
import ErrorsPage from "../pages/module/errors/ErrorsPage";
import PrivateRoutes from "./PrivateRoutes";

//const {PUBLIC_URL} = process.env

const AppRoutes: FC = ()=>{
    return(
        <>
        <BrowserRouter>
            <Routes>
                <Route element={<App />}>
                <Route path="error/*" element={<ErrorsPage />} />
                <Route path="/*" element={<PrivateRoutes />} />
                </Route>
            </Routes>
        </BrowserRouter>
        </>
    )
}

export {AppRoutes}
